import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { CreateDatabasePage } from '@/routes/databases/create-database/page'

export const CreateDatabase = () => {
  return (
    <PageErrorBoundary>
      <CreateDatabasePage />
    </PageErrorBoundary>
  )
}
